define('webshopCategoriesDetailBodyView',[
  'app',
  'module',
  'underscore',
  'settings',
  'rolesMixin',
  'tabsViewView',
  'webshopCategoriesDetailBodyCategoryView',
  'webshopCategoriesDetailBodyTextsView',
  'webshopCategoriesDetailBodySlugsView',
  'webshopCategoriesDetailBodyProductsView',
  'webshopCategoriesDetailBodyUrlsView',
  'webshopCategoriesDetailBodyUrlsV1View',
  'webshopCategoriesDetailBodyImagesView',
  'webshopCategoriesDetailBodyLandingpagesView'
], function (
    App,
    Module,
    _,
    Settings,
    RolesMixin,
    TabsView
) {
  'use strict';

  Module.exports = TabsView.extend({   

    initialize: function () {
      TabsView.prototype.initialize.apply(this, arguments);

      this.selectedTab = this.options.tabName || 'category';
    },

    tabs: function () {
      var items = [];

      items.push({
        name: 'category',
        url: '',
        title: _.i18n('webshop.categories.category.tabTitle'),
        role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_CATEGORY,
        defaultSelected: true,
        view: 'webshopCategoriesDetailBodyCategoryView'
      });

      items.push({
        name: 'texts',
        url: 'texts',
        title: _.i18n('webshop.categories.texts.tabTitle'),
        role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_TEXTS,
        view: 'webshopCategoriesDetailBodyTextsView'
      });

      if (Settings.configValue('webshop.urls.mode') === 'old') {
        items.push({
          name: 'slugs',
          url: 'slugs',
          title: _.i18n('webshop.categories.slugs.tabTitle'),
          role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_SLUGS,
          view: 'webshopCategoriesDetailBodySlugsView'
        });
      }

      items.push({
        name: 'products',
        url: 'products',
        title: _.i18n('webshop.categories.products.tabTitle'),
        role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_PRODUCTS,
        view: 'webshopCategoriesDetailBodyProductsView'
      });

      if (Settings.configValue('webshop.urls.mode') === 'new') {
        items.push({
          name: 'urls',
          url: 'urls',
          title: _.i18n('common.urls'),
          role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_URLS,
          view: 'webshopCategoriesDetailBodyUrlsView'
        });
      }

      if (Settings.configValue('webshop.urls.mode') === 'old') {
        items.push({
          name: 'urlsV1',
          url: 'urlsV1',
          title: _.i18n('common.urls'),
          role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_URLS,
          view: 'webshopCategoriesDetailBodyUrlsV1View'
        });
      }

      items.push({
        name: 'images',
        url: 'images',
        title: _.i18n('common.images'),
        role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_IMAGES,
        view: 'webshopCategoriesDetailBodyImagesView'
      });

      items.push({
        name: 'landingpages',
        url: 'landingpages',
        title: _.i18n('common.landingpages'),
        role: RolesMixin.DASHBOARD_WEBSHOP_CATEGORIES_LANDINGPAGES,
        view: 'webshopCategoriesDetailBodyLandingpagesView'
      });

      return items;
    }
  });
});

